module.exports = __webpack_public_path__ + "static/img/3.ddc3ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/3.png
// module id = E4g6
// module chunks = 0